const defaultUserState = {
  details: null,
  sessionId: null,
  lastUpdated: null,
  sessionCheckPending: false,
};

const userReducer = (state = defaultUserState, action) => {
  switch (action.type) {
    case 'SESSION_CHECK_START':
      return {
        ...state,
        sessionCheckPending: true,
      };
    case 'SESSION_CHECK_END':
      return {
        ...state,
        sessionCheckPending: false,
      };
    case 'SET_USER_DETAILS':
      return {
        ...state,
        details: action.details,
        sessionId: action.sessionId,
        sessionCheckPending: false,
        // This is used by menu.js to allow us to tell when the user's session has timed out.
        // It is updated on every screen load, and every 60 seconds, via SessionCheck component
        // calling getUserDetails() action.
        lastUpdated: new Date().getTime(),
      };
    case 'UNSET_FORCE_PASSWORD_FLAG': {
      // cope with no user details yet
      if (typeof state.details === 'undefined') {
        return state;
      }
      return {
        ...state,
        details: {
          ...state.details,
          passwordResetPending: false,
        },
      };
    }
    case 'LOG_OUT_END':
      return defaultUserState;
    case 'SESSION_EXPIRED':
      return defaultUserState;
    default:
      return state;
  }
};

export default userReducer;
